"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransitApi = void 0;
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
class TransitApi {
}
exports.TransitApi = TransitApi;
/**
 * Socket route name to delete the unused transit nodes
 *
 * @static
 * @memberof TransitApi
 */
TransitApi.DELETE_UNUSED_NODES = 'transitNodes.deleteUnused';
//# sourceMappingURL=transit.js.map